import { easepick, RangePlugin, LockPlugin } from "@easepick/bundle"
import { formatDate } from "./utils"

const CSS_SUFFIX = '47'
const HIDDEN_START_CLASS = 'crafty-range-hidden-start'
const HIDDEN_END_CLASS = 'crafty-range-hidden-end'
const PARENT_CLASS_SELECTOR = '.crafty-date-range-container'
const END_CLASS = 'crafty-range-end'

const setDateAttr = (el, data) => {
  const { dataset } = el

  if (data.end) {
    dataset.endDate = formatDate(data.end, "yyyy-MM-dd")
  } else {
    el.removeAttribute('data-end-date')
  }

  if (data.start) {
    dataset.startDate = formatDate(data.start, "yyyy-MM-dd")
  } else {
    el.removeAttribute('data-start-date')
  }
  // for two date inputs 
  const parent = el.closest(PARENT_CLASS_SELECTOR)
  const endEl = parent?.querySelectorAll(`.${END_CLASS}`)[0]
  if (endEl) {
    const endDataSet = endEl.dataset
    if (data.end) {
      endDataSet.endDate = formatDate(data.end, "yyyy-MM-dd")
    } else {
      endEl.removeAttribute('data-end-date')
    }
  }
}


const cancel = (picker, element) => {
  picker.clear()
  if (containsHiddenField()) updateHiddenFields(element, {startDate: null, endDate: null})
  setDateAttr(element, {startDate: null, endDate: null})
  picker.hide()
  element.dispatchEvent(new Event('change'))
  element.dispatchEvent(new CustomEvent('dateSelected', {detail: { picker }}))
}

const setupDateRange = (picker, element, { elementEnd }) => {
  const {startDate, endDate } = element.dataset
  const formattedStartDate = startDate ? formatDate(startDate) : 'MM/DD/YYYY'
  const formattedEndDate = endDate ? formatDate(endDate) : 'MM/DD/YYYY'


  if (!elementEnd) {
    element.value = `${formattedStartDate} - ${formattedEndDate}`
  }

  picker.on('click', (e) => {
    const { target } = e
    const isCancelButton = [ ...target.classList].includes('cancel-button')
    if ( isCancelButton ) cancel(picker, element)
  })

  picker.on('select', (e) => {
    if (containsHiddenField()) updateHiddenFields(element, e.detail)        
    setDateAttr(element, e.detail)
    element.dispatchEvent(new Event('change'))
    element.dispatchEvent(new CustomEvent('dateSelected', {detail: { picker }}))
  })
}

const addDrawerClass = (picker) => {
  const { container } = picker.ui
  container?.classList?.add('crafty-drawer-calendar')
}

const containsHiddenField = () => {
  return document.getElementsByClassName(HIDDEN_START_CLASS).length || document.getElementsByClassName(HIDDEN_END_CLASS).length
}

const updateHiddenFields = (element, detail) => {
  const {start, end} = detail
  const formattedStartDate = formatDate(start, "yyyy-MM-dd")
  const formattedEndDate = formatDate(end, "yyyy-MM-dd")
  const parent = element.closest(PARENT_CLASS_SELECTOR)
  const startEl = parent.querySelectorAll(`.${HIDDEN_START_CLASS}`)[0]
  const endEl = parent.querySelectorAll(`.${HIDDEN_END_CLASS}`)[0]
  if (startEl) startEl.value = formattedStartDate
  if (endEl) endEl.value = formattedEndDate
}

const minDate = (element) => element.dataset.minDate
const maxDate = (element) => element.dataset.maxDate
const minDays = (element) => Number(element.dataset.minDays)
const maxDays = (element) => Number(element.dataset.maxDays)

export const picker = (element, {dateRange=false, elementEnd, inDrawer=false }) => {
  const origin = window.location.origin
  const cssFileName = 'easepick'
  const lockRequirements = ['minDate', 'maxDate', 'minDays', 'maxDays']
  const includeLockPlugIn = Object.keys({ ...element.dataset }).some((attr) => lockRequirements.includes(attr))
  const removeAutoApplyRequirements = ['cancelButton']
  const removeAutoApply = Object.keys({ ...element.dataset }).some((attr) => removeAutoApplyRequirements.includes(attr))
  const includeRangePlugin = dateRange
  const basePlugins = []
  const plugins = [ 
    ...basePlugins,
    ...(includeRangePlugin) ? [RangePlugin] : [],
    ...(includeLockPlugIn) ? [LockPlugin] : [],
  ]
  const baseOptions = {
      element,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.0/dist/index.css',
        'https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.0/dist/index.css',
        `${origin}/${cssFileName}-${CSS_SUFFIX}.css`,
      ],
      format: "MM/DD/YYYY",
      plugins, 
      tooltip: false, 
      calendars: dateRange ? 2 : 1,
      autoApply: !removeAutoApply,
      grid: dateRange ? 2 : 1,
      locale: {
        cancel: 'Clear',
      },
      setup(picker) {
        if (dateRange) setupDateRange(picker, this.element, { elementEnd })
        if (inDrawer) addDrawerClass(picker)
      },
    }
    const options = {
      ...baseOptions, 
      ...(elementEnd && {RangePlugin: {elementEnd, repick: true}}),
      ...(includeLockPlugIn && {LockPlugin: {
        ...(minDate(element) && { minDate: minDate(element) }),
        ...(maxDate(element) && { maxDate: maxDate(element) }),
        ...(maxDays(element) && { maxDays: maxDays(element) }),
        ...(minDays(element) && { minDays: minDays(element) }),
      }}),
    }

    return new easepick.create(options)
}


